import * as React from 'react'

const CouponIcon = (props: any) => {
  console.log('rendering coupon')
  return (
    <svg
      {...props}
      className={'icon ' + props.className}
      width='512'
      height='512'
      viewBox='0 0 512 512'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <g>
          <path d='M501.344,117.338H149.343L128,138.671l-21.328-21.333h-96C4.779,117.338,0,122.113,0,128.005v255.999 c0,5.893,4.779,10.658,10.672,10.658h96L128,373.348l21.343,21.314h352.001c5.892,0,10.656-4.766,10.656-10.658V128.005 C512,122.113,507.235,117.338,501.344,117.338z M490.677,373.348H158.172l-15.079-15.088L128,343.162l-15.078,15.098 l-15.079,15.088h-76.5V138.671h76.5l15.079,15.083L128,168.838l15.093-15.083l15.079-15.083h332.505V373.348z' />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M277.343,170.671c-23.563,0-42.671,19.108-42.671,42.667c0,23.564,19.107,42.667,42.671,42.667
						c23.56,0,42.657-19.103,42.657-42.667C320,189.779,300.902,170.671,277.343,170.671z M277.343,234.671
						c-11.765,0-21.343-9.573-21.343-21.333c0-11.764,9.578-21.333,21.343-21.333s21.334,9.569,21.334,21.333
						C298.677,225.098,289.108,234.671,277.343,234.671z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M362.677,256.005c-23.569,0-42.677,19.099-42.677,42.657c0,23.558,19.107,42.686,42.677,42.686
						c23.559,0,42.667-19.127,42.667-42.686C405.344,275.103,386.235,256.005,362.677,256.005z M362.677,320.004
						c-11.774,0-21.333-9.559-21.333-21.342c0-11.756,9.559-21.314,21.333-21.314c11.765,0,21.323,9.559,21.323,21.314
						C384,310.445,374.441,320.004,362.677,320.004z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M394.677,170.672c-2.941,0-5.618,1.191-7.55,3.123L237.799,323.133c-1.926,1.932-3.127,4.588-3.127,7.529
						c0,5.902,4.779,10.686,10.671,10.686c2.937,0,5.608-1.205,7.549-3.127l149.324-149.343c1.941-1.927,3.128-4.593,3.128-7.539
						C405.344,175.451,400.559,170.672,394.677,170.672z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M128,181.338c-5.873,0-10.657,4.774-10.657,10.667s4.785,10.667,10.657,10.667c5.907,0,10.672-4.774,10.672-10.667
						S133.907,181.338,128,181.338z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M128,224.005c-5.873,0-10.657,4.774-10.657,10.667c0,5.888,4.785,10.667,10.657,10.667
						c5.907,0,10.672-4.779,10.672-10.667C138.672,228.779,133.907,224.005,128,224.005z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M128,266.672c-5.873,0-10.657,4.773-10.657,10.676c0,5.873,4.785,10.656,10.657,10.656
						c5.907,0,10.672-4.783,10.672-10.656C138.672,271.445,133.907,266.672,128,266.672z'
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d='M128,309.348c-5.873,0-10.657,4.766-10.657,10.656c0,5.893,4.785,10.658,10.657,10.658
						c5.907,0,10.672-4.766,10.672-10.658C138.672,314.113,133.907,309.348,128,309.348z'
          />
        </g>
      </g>
    </svg>
  )
}

export default CouponIcon



// WEBPACK FOOTER //
// ./src/components/icons/ui/coupon.tsx